import { Button, Card, CardContent, CircularProgress, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CONTENT_COLOR, ROLE_ADMIN } from "../../models/Constants";
import { Credential } from "../../models/Index";
import { ApplicationState, actionCreators, selectors } from "../../store";
import ToastContainer from "../common/ToastContainer";
import MFADialog from "../dialogs/MFADialog";
import LoginForm from "./LoginForm";
import { useDispatch } from "react-redux";
import { AuthorizeAction } from "../../store/AppStore";
import { getAdmin } from "../CallApi";
// -------------
// Props
export type LoginProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

// -------------
// Component
export const Login = (props: LoginProps) => {
  const {
    isAuthorize,
    userRole,
    // onSubmit,
    // onVerificationCode,
    // onCancleVerification,
    // onExitResetPassword,
  } = props;

  const [loadingFlag, setLoadingFlag] = useState(false);
  const [openMFADialog, setOpenMFADialog] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  let navigate = useNavigate();
  const dispatch = useDispatch()
  // useEffect(() => {
  //   onExitResetPassword();
  // }, [])

  useEffect(() => {
    //HANDLE USER
   
    if (isAuthorize) {
      navigate('/home');
    }
  }, [isAuthorize])

  const onLogin = async (loginData: Credential) => {
    // localStorage.setItem("prevLocation", "projects"); //Mock
    // onSubmit(loginData);
    setLoadingFlag(true)
    await getAdmin(loginData.password).then((result:any)=>{
      if (result.success && result.data.data) {
        setLoadingFlag(false)
        dispatch({
          type: "AUTHORIZE",
          payload: {userProfile: {"userName":"Admin"}}
        });
      } else {
        setLoadingFlag(false)
         dispatch(
          actionCreators.showMessage({
            type: "error",
            title: "ログイン",
            body: "ログインに失敗しました。",
          })
        );
      }
    })

  };

  return (
    <>
      {loadingFlag && (
        <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1500, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
          <CircularProgress />
        </div>
      )}
    
      <Stack style={{ height: '100vh', background: '#F9FAFB'}} justifyContent={'flex-start'}>
        <Stack justifyContent="center" alignItems="center" mt={2}>
          <Typography sx={{color:CONTENT_COLOR, fontSize:40, fontWeight:"bold"}}>ストレス耐性テスト 管理者用</Typography>
          <Card sx={{ width: 400, boxShadow: 5, marginTop: 3 }}>
            <CardContent>
              <LoginForm handleDataLogin={onLogin} />
            
            </CardContent>
          </Card>
        </Stack>
      
      </Stack >
      <ToastContainer />
    </>
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  isAuthorize: selectors.isAuthorize(state),
 
  userRole: state.app.user?.userRole,
})

const mapDispatchToProps = {
  
};

export default connect(mapStateToProps, mapDispatchToProps)(Login as any);
